import {Component} from 'react';
import h from 'react-hyperscript';
import Login from 'Pages/Login/Login';
import OptIn from 'Pages/OptIn/OptIn';
import {Route} from 'react-router';
import {OptedInContext} from '../../App';

const DistrictRouteWrapper = (props) => {
  return (
    h(OptedInContext.Consumer, {}, ({optedIn, setOptedIn}) => {
      return h(DistrictRoute, {
        optedIn, setOptedIn, ...props,
      });
    })
  );
};

class DistrictRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
    };
  }

  componentDidMount() {
    this.checkIfLoggedIn();
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.checkIfLoggedIn();
    }
  }

  checkIfLoggedIn() {
    if (this.props.userStatus && this.props.googleUser) {
      this.setIsLoggedIn(true);
    } else {
      this.setIsLoggedIn(false);
    }
  }

  setIsLoggedIn(value) {
    this.setState({
      isLoggedIn: value,
    });
  }

  render() {
    if (this.state.isLoggedIn) {
      const {dynamicGraphSize, screenWidth} = this.props;

      if (this.props.optedIn) {
        return (
          h(Route, {
            exact: true,
            path: this.props.path,
            render: ({match}) => {
              return (
                h(this.props.component, {
                  key: this.props.key,
                  csrf: this.props.csrf,
                  needsDistrictConfig: this.state.needsDistrictConfig,
                  googleUser: this.props.googleUser,
                  idToken: this.props.googleUser.getAuthResponse().id_token,
                  userStatus: this.props.userStatus,
                  setReportName: this.props.setReportName,
                  setLatestReportName: this.props.setLatestReportName,
                  productWindowsLoading: this.props.productWindowsLoading,
                  key: this.props.key,
                  csrf: this.props.csrf,
                  path: this.props.path,
                  logoutClick: this.props.logoutClick,
                  fetchUserStatus: this.props.fetchUserStatus,
                  isAdmin: this.props.isAdmin,
                  match,
                  dynamicGraphSize,
                  screenWidth,
                }, null)
              );
            },
          }, null)
        );
      } else {
        return (
          h(OptIn, {
            handleOptedIn: this.props.setOptedIn,
            googleUser: this.props.googleUser,
            csrf: this.props.csrf,
          }, null)
        );
      }
    } else {
      return (
        h(Login, {
          key: this.props.key,
          path: this.props.path,
          loginClick: this.props.loginClick,
        }, null)
      );
    }
  }
}

export default DistrictRouteWrapper;
